import moment from "moment";
import React from "react";
import close from "../../../../../assets/close.svg";
import ReplyContactUs from "../../../../../Util/DataTable/ModalContentAdmin/ReplyContactUs/ReplyContactUs";
import { formatPhoneNumber, stripHTMLToPlainText } from "../../../../../Util/helper";
import "./ViewContactUs.css";

export default function ViewContactUs(props) {
    const closeModal = () => {
        props.closeModal();
    }
    const replies = (props?.data?.contact_us_replies || []).sort((a, b) => new Date(a.id) - new Date(b.id));

    return (
        <div className="modal contact-us">
            <div className="modal-header">
                <h2>Contact Us Details</h2>
                <div class="description">
                    <span className="value">
                        {props?.data?.full_name ? props.data.full_name : 'N/A'} ({props?.data?.email ? props.data.email : 'N/A'})
                    </span>
                    {!!props?.data?.phone?.trim() &&
                        <span className="value">
                            {props?.data?.phone ? formatPhoneNumber(props.data.phone) : 'N/A'}
                        </span>
                    }
                    <span className="value">
                        <strong> Issue Resolved: {props?.data?.resolved ? 'Yes' : 'No'}</strong>
                    </span>
                </div>
                {!!(props?.data?.address?.trim() || props?.data?.city?.trim() || props?.data?.zip?.trim()) &&
                    <span className="value address">
                        {props?.data?.address ? `${props.data.address}` : ''} {props?.data?.city ? `, ${props.data.city}` : ''} {props?.data?.zip ? ` ${props.data.zip}` : ''}
                    </span>
                }
                <span className="close" onClick={closeModal}>
                    <img src={close} alt='close-icon' />
                </span>
            </div>
            <div className="modal-body">
                <div className="contact-chat-block">
                    <div className="inner-blk you">
                        <div className="inner-msg-content">
                            <p className="time">{moment(props?.data?.created_at).format('MM/DD/YYYY, h:mm a')}</p>
                            <div className="value">
                                {props?.data?.message ? props.data.message : 'N/A'}
                            </div>
                        </div>
                    </div>
                    {!!replies?.length && <div className="inner-blk me">
                        {replies?.map((reply, index) => (
                            <div key={index} className="inner-msg-content">
                                <p className="time">{moment(reply?.created_at).format('MM/DD/YYYY, h:mm a')}</p>
                                <div className="value">{stripHTMLToPlainText(reply?.message)}</div>
                            </div>
                        ))}
                    </div>}
                </div>
                <ReplyContactUs data={props.data} refresh={() => props.refresh()} />
            </div>
        </div>
    )
}